import React, { useEffect } from 'react'
import { SubmitButton, CancelButton, Container } from './style/RMAReturnButtonsWMO.css'

const RMAReturnButtonsWMO = (props) => {
  const {
    idName,
    buttonLabel,
    submitForm,
    displayCancelConfirmation,
    isPartEligible,
    setButtonText,
    itemList,
    partReturnEligibilityList,
  } = props

  const DoneButton = () => {
    displayCancelConfirmation()
  }

  if (!isPartEligible) {
    setButtonText("Done");
  }

  const areAllItemsReturnIneligible = (arr) => {
    const areAllFalse = arr.every((value) => value === false);
    return areAllFalse;
  };

  useEffect(() => {
    const partReturnEligibilityArray = Object.values(partReturnEligibilityList);
    if (
      partReturnEligibilityArray.length == itemList.length &&
      areAllItemsReturnIneligible(partReturnEligibilityArray)
    )
      setButtonText("Done");
  }, [partReturnEligibilityList]);

  const displayCancel = buttonLabel === 'Done' ? false : true

  return (
    <>
      <Container>
        <SubmitButton
          id={idName}
          onClick={submitForm}
          type="submit"
        >
          {buttonLabel}
        </SubmitButton>
        {isPartEligible && displayCancel && (
          <CancelButton onClick={DoneButton} type='button'>
            Cancel Return
          </CancelButton>
        )}
      </Container>
    </>
  )
}

export default RMAReturnButtonsWMO
